import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generateObjectId } from '@builttocreate/engine-utils';

import Popover from '../../misc/Popover';
import MetadataSettings from './MetadataSettings';
import InputSettingsField from './InputSettingsField';
import { StyledFieldWrapper } from './SettingsCommonElements';

class OptionSettingsModal extends Component {

  static propTypes = {
    id: PropTypes.string,
    display: PropTypes.bool,
    option: PropTypes.object,
    onHide: PropTypes.func,
    hideWidth: PropTypes.bool,
    config: PropTypes.object
  }

  static defaultProps = {
    config: {},
  }

  constructor(props) {
    super(props);
    this.state = { form: {} };
  }

  componentDidUpdate(prevProps) {

    const { option } = this.props;

    if (option !== prevProps.option) {

      const form = option && option._id ? { ...option } : { _id: generateObjectId(), value: 'New Option', width: 200 };

      this.setState({ form });

    }

  }

  render() {

    const { children, id, display, config, hideWidth } = this.props;
    const { form } = this.state;

    return (
      <Popover
        resposition={false}
        positions={['left', 'top', 'bottom']}
        isOpen={display}
        onClose={this.handleHide}
        onSubmit={this.handleSubmit}
        content={(
          <>
            <StyledFieldWrapper>
              <InputSettingsField
                inputStyles={{ padding: 4 }}
                fieldId={id}
                label="Value"
                value={form.value}
                type="textarea"
                rows={2}
                onChange={(fieldId, value) => this.handleInputChange('value', value)}
              />
            </StyledFieldWrapper>
            {config.width === false || hideWidth ? null : (
              <StyledFieldWrapper>
                <InputSettingsField
                  inputStyles={{ padding: 4 }}
                  fieldId={id}
                  label="Width"
                  value={form.width}
                  type="number"
                  onChange={(fieldId, value) => {
                    this.handleInputChange('width', value ? parseInt(value, 10) : 0);
                  }}
                />
              </StyledFieldWrapper>
            )}
            <MetadataSettings
              metadata={form.metadata}
              metadataOptions={config.metadata}
              onChange={(changes) => this.handleMetadataChange(changes)}
            />
          </>
        )}
      >
        {children}
      </Popover>
    );

  }

  handleInputChange = (key, value) => {

    const { form } = this.state;

    const nextForm = { ...form, [key]: value };

    this.setState({ form: nextForm });

  }

  handleMetadataChange = (changes) => {

    const { form } = this.state;

    const metadata = form.metadata ? { ...form.metadata } : {};
    const nextMetadata = { ...metadata, ...changes };

    const nextForm = { ...form, metadata: nextMetadata };

    this.setState({ form: nextForm });

  }

  handleSubmit = () => {

    const { form } = this.state;
    const { onSubmit } = this.props;

    const nextForm = { ...form };

    if (!nextForm._id) nextForm._id = generateObjectId();

    if (onSubmit) onSubmit(nextForm._id, nextForm);

    this.handleHide();

  }

  handleHide = () => {

    const { onHide } = this.props;

    this.clearForm();

    if (onHide) onHide();

  }

  clearForm = () => {

    this.setState({ form: {} });
  }

}

export default OptionSettingsModal;
